import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEETS_BY_PROVIDER_BY_STATUS, GET_TIMESHEETS_BY_PROVIDER } from "src/api-setup/api-endpoints";
import { transformDateTime } from "src/lib/date-time.util";
import { API_CONSTANTS } from "../utils/constants";

export const getTimesheetsByProvider = async (
  cookiesData,
  dispatch,
  providerId,
  startDate,
  endDate,
  taskCategoryMstrKey = null,
  statusMstrKey = null,
  sortColumn = "t.timesheet_mstr_key",
  sortNumber = 1,
  sortOrder = "ASC",
  pageRowOffset = 0,
  pageRows = null,
  columnFilters = null
) => {
  if (!cookiesData || !providerId) {
    return {
      timesheets: [],
      totalRows: 0,
    };
  }

  try {
    const apiHeaders = generateHeader();

    const startDateString = startDate
      ? transformDateTime({
          date: startDate,
          format: "YYYY-MM-DD",
          includeTime: true,
        })
      : null;
    const endDateString = endDate
      ? `${transformDateTime({
          date: endDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 23:59:59`
      : null;

    // Extract export flag from columnFilters if present, otherwise default to 0
    const exportFlag = columnFilters?.in_export_flag !== undefined ? columnFilters.in_export_flag : 0;
    const { in_export_flag, ...filterParams } = columnFilters || {};

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_status: statusMstrKey, //OPTIONAL
      in_filter: null,
      in_export_flag: exportFlag,
      ...filterParams,
      in_sort_number: sortNumber,
      in_sort_order: sortOrder,
      in_start_date: startDateString,
      in_end_date: endDateString,
      in_page_row_offset: pageRowOffset,
    };

    if(pageRows) {
      requestBody.in_page_rows = pageRows;
    }

    const response = await POSTAPI(
      false,
      GET_TIMESHEETS_BY_PROVIDER_BY_STATUS,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );
    if (response && response.data && response.data.out_parameters) {
      const { out_ret_code, out_total_rows, out_error_msg, out_column_labels } = response.data.out_parameters;
      const rowResult = response.data.row_result || [];

      if (out_ret_code === API_CONSTANTS.SUCCESS_CODE || out_ret_code === API_CONSTANTS.RECORDS_NOT_FOUND_CODE) {
        return {
          timesheets: rowResult,
          totalRows: rowResult.length || 0,
        };
      } else {
        return {
          timesheets: [],
          totalRows: 0,
        };
      }
    }

    return {
      timesheets: [],
      totalRows: 0,
    };
  } catch (error) {
    console.error("Error fetching timesheets by provider:", error);
    return {
      timesheets: [],
      totalRows: 0,
    };
  }
};
